import { Button, Result } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import LayoutComponent from '../../components/LayoutComponent/LayoutComponent';
import { HomeFilled } from '@ant-design/icons';
import configuration from '../../configs/IConfiguration';
import styles from './LoginErrorPage.module.scss';

const LoginErrorPage = (): React.ReactElement => {
    /*** EFFECTS ***/

    /** METHODS **/

    /*** COMPONENTS ***/

    return (
        <LayoutComponent pageId="loginError" style={{ background: '#f2f2f2' }}>
            <Result
                status="500"
                title={<FormattedMessage id="loginError.title" />}
                subTitle={<FormattedMessage id="loginError.description" />}
            />
            <a className={styles.goToHome} href={`${configuration.getParentUrl()}`}>
                <Button icon={<HomeFilled />} type="primary">
                    <FormattedMessage id="button.goToHome" tagName="span" />
                </Button>
            </a>
        </LayoutComponent>
    );
};

export default LoginErrorPage;
